import tree from "../../../../components/tree.vue";
import iTable from "../../../../components/Table.vue";
import IPagination from "../../../../components/demo.vue";
import MonthTime from "./MonthTime/MonthTime.vue";
import ChangeTime from "./ChangeTime/ChangeTime.vue";

export default {
    name: 'DriverDuration',
    components: {
        tree,
        iTable,
        IPagination,
        MonthTime,
        ChangeTime
    },
    data() {
        return {
            isCollapse: false,
            stateArrow: true,
            driverNum: '',
            name: '',
            isSearch: true,
            activeName: 'first',
            orgId: '',
            height: '320',
            list: [], 
            option: {
                stripe: true, 
                border: true,
                loading: false, 
                highlightCurrentRow: false, 
                height: false,
                mutiSelect: false, 
                serialNumber: false, 
            },
            columns: [
                {
                    prop: "name",
                    label: this.$t('DriverAnalysis.name'),
                    align: "center",
                },
                {
                    prop: "workTime",
                    label: this.$t('DriverAnalysis.todayWork'),
                    align: "center",
                },
            ],
            operates: {
                width: 100,
                fixed: "right",
                list: [],
            },
            currentPage: 1, 
            pageSize: 10, 
            total: 1, 
        };
    },
    mounted() {

    },
    methods: {
        toggleSideBar() {
            this.isCollapse = !this.isCollapse
            this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
        },
        changeArrow() {
            this.stateArrow = !this.stateArrow
        },
        onkeyUp() {
            this.currentPage = 1
            this.pageSize = 10
            this.queryCarMaintain()
        },
        queryCarMaintain() {
            this.tableLoading = true
            let param = {
                orgId: Number(this.orgId),
                pageSize: this.pageSize,
                pageNum: this.currentPage,
                name: this.name,
            };
            this.$store.dispatch('DriverAnalysis/GET_SELECTDRIVERTODAYWORKTIMEPAGE', param).then(res => {
                if (res) {
                    if (res.data.code == 200) {
                        this.list = res.data.data.list;
                        this.$refs.page.CommandTotal = res.data.data.total
                    }
                }
                this.tableLoading = false
            }).catch(err => { this.tableLoading = false })
        },
        handleClick(event) {
            this.activeName = event.name
            if (this.activeName == 'first') {
                this.$nextTick(() => {
                    this.$refs.monthTime.orgId = this.orgId
                    this.$refs.monthTime.getDayUseRate()
                    this.$refs.monthTime.initQuery('all')
                })
            } else {
                this.$nextTick(() => {
                    this.$refs.changeTime.orgId = this.orgId
                    this.$refs.changeTime.getDayUseRate()
                    this.$refs.changeTime.initQuery('all')
                })

            }
        },
        initQuery(item) {
            this.orgId = item.id
            this.queryCarMaintain()
            if (this.activeName == 'first') {
                this.$refs.monthTime.orgId = this.orgId
                this.$refs.monthTime.getDayUseRate()
                this.$refs.monthTime.initQuery('all')
            }
        },
        nodeClick(val) {
            this.orgId = val.label
            this.queryCarMaintain()
            if (this.activeName == 'first') {
                this.$refs.monthTime.driverNum = ''
                this.$refs.monthTime.orgId = val.label
                this.$refs.monthTime.getDayUseRate()
                this.$refs.monthTime.initQuery('all')
            } else {
                this.$refs.changeTime.driverNum = ''
                this.$refs.changeTime.orgId = val.label
                this.$refs.changeTime.getDayUseRate()
                this.$refs.changeTime.initQuery('all')
            }
        },
        rowClick(row) {
            this.driverNum = row.driverNum
            if (this.activeName == 'first') {
                this.$refs.monthTime.driverNum = row.driverNum
                this.$refs.monthTime.getDayUseRate()
                this.$refs.monthTime.initQuery('one')
                this.$refs.monthTime.isShow = false
            } else {
                this.$refs.changeTime.driverNum = row.driverNum
                this.$refs.changeTime.getDayUseRate()
                this.$refs.changeTime.initQuery('one')
                this.$refs.changeTime.isShow = false
            }
        },
        changeSize(item) {
            this.pageSize = item.pageSize
            this.currentPage = item.pageNum
            this.queryCarMaintain();
        },
        onResize: function (x, y, width, height) {
            let box = document.getElementById("leftBox");
            box.style.width = width + "px";
        },
    },
};
